import React, { useState } from 'react';
import { Divider, Layout, theme, Typography } from 'antd';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../Assets/Styles/Home.module.css';
import { ConventionSignProvider } from '../context/ConventionSignContext';
import { Sidebar } from '../Components/Navigation/Sidebar';
import { AppFooter } from '../Components/AppFooter';
import { AppHeader } from '../Components/AppHeader';
import { useCurrentUser } from '../hooks/useCurrentUser';
import { ErrorBoundary } from '@sentry/react';
import { dashboardRoutes } from '../Components/Navigation/dashboardRoutes';
import { ErrorPage } from './ErrorPage';
const { Content } = Layout;

function HomePage(): React.ReactNode {
  const { t } = useTranslation();
  const loggedInUser = useCurrentUser();
  const [activeMenu, setActivMenu] = useState<string>('');
  const [collapsed, setCollapsed] = useState(true);
  const { token } = theme.useToken();

  const currentRoute = dashboardRoutes.find((route) =>
    location.pathname.includes(route.path)
  );
  const tabTitle: string = currentRoute?.labelKey ?? '';

  return (
    <Layout style={{ height: '100vh', overflow: 'hidden' }}>
      <AppHeader
        isLoginPage={false}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />
      <ErrorBoundary fallback={<ErrorPage />}>
        <Layout hasSider style={{ overflow: 'hidden' }}>
          {loggedInUser && (
            <Sidebar
              collapsed={collapsed}
              setCollapsed={setCollapsed}
              onMenuSelect={setActivMenu}
              activeMenu={activeMenu}
            />
          )}

          <Layout
            style={{
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Content
              style={{
                backgroundColor: token.colorBgContainer,
                flex: '1 0 auto',
              }}
            >
              <ConventionSignProvider>
                <div
                  style={{
                    margin: '16px 0px 0px 0px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Typography.Title
                    level={3}
                    style={{ margin: 0, fontSize: '23px', fontWeight: 600 }}
                  >
                    {t(tabTitle)}
                  </Typography.Title>
                </div>

                <Divider
                  size="small"
                  style={{ marginBottom: 15, borderTopWidth: '2px' }}
                />

                {/* react router navigate to components and display with outlet */}
                <Outlet />
              </ConventionSignProvider>
            </Content>

            <AppFooter />
          </Layout>
        </Layout>
      </ErrorBoundary>
    </Layout>
  );
}

export default HomePage;
